export const DEFAULT_CHIEF_PATH = '/dashboard/v1/chief'
export const DEFAULT_ADMIN_PATH = '/dashboard/v1/admin'
